import { createAction, props } from "@ngrx/store";

export const FETCH_ROOM_LIST = createAction(
    'FETCHROOMLIST',
    props<{ rooms: any }>()
);